// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea-module__textArea___cNuTQ","hasError":"TextArea-module__hasError___NURXX","disabled":"TextArea-module__disabled___X5bPk"};